<div class="estatisticas-cadastro">
    <app-painel-lateral
        [tituloPainel]="obterAgrupadorSelecionado().label"
        [descricaoPainel]="obterAgrupadorSelecionado().descricao"
        [iconePainel]="obterAgrupadorSelecionado().icon"
        [filtrosTemplate]="filtros"
        [conteudoTemplate]="conteudo"
        [ocultarFiltros]="!!estatisticaSelecionada"
    >
        <ng-template #filtros>
            <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF do estado</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
            </label>

            <label class="ano-filtro" for="estatisticas-cadastro-ano">
                <span class="mapa-filtro-label">Ano</span>
                <input id="estatisticas-cadastro-ano" class="ano-input p-inputtext" type="number" min="1900" [max]="anoAtual + 1" [(ngModel)]="anoSelecionado" />
            </label>

            <p-button icon="pi pi-refresh" label="Atualizar" type="button" (onClick)="aplicarFiltros()"></p-button>
        </ng-template>

        <ng-template #conteudo>
            @if (estatisticaSelecionada) {
                <app-detalhamento-pendencias
                    [indicador]="obterIndicadorAnalitico()"
                    [linhas]="linhasAnalitico"
                    [first]="firstAnalitico"
                    [rows]="rowsAnalitico"
                    [totalRecords]="totalRegistrosAnalitico"
                    [carregando]="carregandoAnalitico"
                    [rotuloVoltar]="'Voltar às estatísticas'"
                    [colunaDetalhe]="obterColunaDetalheAnalitico()"
                    [voltarNoCard]="true"
                    [permitirVisualizacaoCard]="true"
                    (voltar)="voltarParaEstatisticas()"
                    (paginaAlterada)="onPageChangeAnalitico($event)"
                >
                    <section detalhamento-acoes class="analitico-filtros-card">
                        <div class="analitico-filtros-card-header">
                            <span class="analitico-filtros-card-icon"><i class="pi pi-filter"></i></span>
                            <h3 class="analitico-filtros-card-title">Filtros</h3>
                        </div>

                        <label class="analitico-filtro" for="estatisticas-cadastro-grupo-analitico">
                            <span class="mapa-filtro-label">Indicador</span>
                            <select id="estatisticas-cadastro-grupo-analitico" class="analitico-select" [ngModel]="grupoAnaliticoCodigo" (ngModelChange)="onGrupoAnaliticoChange($event)">
                                @for (opcao of obterOpcoesGrupoAnalitico(); track opcao.codigo) {
                                    <option [ngValue]="opcao.codigo">{{ obterDescricaoItem(opcao) }}</option>
                                }
                            </select>
                        </label>
                    </section>
                </app-detalhamento-pendencias>
            } @else {
                @let agrupador = obterAgrupadorSelecionado();

                @for (secao of obterSecoesEstatisticas(); track secao.titulo) {
                    <section class="estatistica-secao">
                        @if (secao.mostrarTitulo) {
                            <h3 class="subsecao-titulo">{{ secao.titulo }}</h3>
                        }
                        <div class="estatisticas-grid" [attr.aria-label]="secao.mostrarTitulo ? secao.titulo : 'Estatísticas do agrupador selecionado'">
                            @for (grupo of secao.grupos; track grupo.id) {
                                <div
                                    class="card-entrada card-entrada-1"
                                    [ngClass]="[grupo.classeGrupo, 'span-' + grupo.visualizacao]"
                                    [class.estatistica-card-linha-inteira]="grupo.linhaInteira"
                                    role="button"
                                    tabindex="0"
                                    [attr.aria-label]="'Maximizar ' + grupo.titulo"
                                    (click)="maximizarGrupo(grupo)"
                                    (keydown.enter)="maximizarGrupo(grupo)"
                                    (keydown.space)="$event.preventDefault(); maximizarGrupo(grupo)"
                                >
                                    <app-card-content [border]="false" [title]="grupo.titulo" [subtitle]="grupo.descricao" [icon]="agrupador.icon">
                                        <div card-header class="flex items-center gap-2" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                                            @if (possuiAnalitico(grupo)) {
                                                <p-button
                                                    icon="pi pi-table"
                                                    styleClass="botao-topo-acao"
                                                    [text]="true"
                                                    [rounded]="true"
                                                    title="Visualizar dados estatísticos"
                                                    ariaLabel="Visualizar dados estatísticos"
                                                    (onClick)="$event.stopPropagation(); selecionarEstatisticaAnalitica(grupo)"
                                                ></p-button>
                                            }
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="$event.stopPropagation(); maximizarGrupo(grupo)"
                                            ></p-button>
                                        </div>

                                        @if (grupo.visualizacao !== 'kpi') {
                                            <div class="estatistica-total-bloco">
                                                @if (obterTotalGrupo(grupo) !== null) {
                                                    <span class="estatistica-total-valor">{{ obterTotalGrupo(grupo) | number }}</span>
                                                    <span class="estatistica-total-label">{{ grupo.rotuloTotal }}</span>
                                                } @else {
                                                    <p-skeleton width="92px" height="30px" />
                                                }
                                            </div>
                                        }

                                        <div class="estatistica-lista">
                                            @if (grupo.carregando) {
                                                @for (linha of [1, 2, 3, 4]; track linha) {
                                                    <div class="estatistica-linha">
                                                        <div class="estatistica-linha-texto">
                                                            <p-skeleton width="130px" height="16px" />
                                                            <p-skeleton width="80px" height="12px" />
                                                        </div>
                                                        <p-skeleton width="56px" height="20px" />
                                                    </div>
                                                }
                                            } @else if (grupo.itens?.length) {
                                                <ng-container *ngTemplateOutlet="conteudoEstatistica; context: { $implicit: grupo, modal: false }"></ng-container>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>
                            }
                        </div>
                    </section>
                }
            }
        </ng-template>
    </app-painel-lateral>
</div>

<ng-template #conteudoEstatistica let-grupo let-modal="modal">
    @switch (grupo.visualizacao) {
        @case ('transferencias') {
            <div class="transferencias-horizontal-layout" [style.max-height]="modal ? '400px' : null">
                @for (item of grupo.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                    @let ufTransferencia = obterUfTransferencia(item);
                    <div class="transferencia-linha">
                        @if (obterBandeiraUf(ufTransferencia); as bandeiraUf) {
                            <img [src]="bandeiraUf" [alt]="ufTransferencia" class="transferencia-uf-bandeira" />
                        }
                        <div class="transferencia-linha-conteudo">
                            <div class="transferencia-linha-dados">
                                <span class="transferencia-linha-uf-nome">{{ ufTransferencia || obterDescricaoItem(item) }}</span>
                                <span class="transferencia-linha-total">{{ item.total ?? 0 | number }}</span>
                            </div>
                            <span class="transferencia-linha-barra"><span [style.width]="obterLarguraBarra(grupo, item)"></span></span>
                        </div>
                    </div>
                }
            </div>
        }
        @case ('linha') {
            <div [class]="modal ? 'modal-grafico-container' : 'estatistica-grafico-container'">
                <p-chart [type]="obterTipoGrafico(grupo)" [data]="obterDadosGrafico(grupo)" [options]="obterOpcoesGrafico(grupo, modal)"></p-chart>
            </div>
        }
        @case ('kpi') {
            <div class="estatistica-kpi-container" [class.modal-kpi]="modal" [class.kpi-media-especialidades]="!modal && grupo.id === 'media-especialidades'">
                <div class="kpi-valor-grande">{{ obterTotalGrupo(grupo) | number }}</div>
                <div class="kpi-unidade-grande">{{ grupo.rotuloTotal }}</div>
            </div>
        }
        @case ('rosca') {
            @if (isSpeedometer(grupo)) {
                <div class="speedometer-container" [class.modal-speedometer]="modal">
                    <p-chart [type]="obterTipoGrafico(grupo)" [data]="obterDadosGrafico(grupo)" [options]="obterOpcoesGrafico(grupo, modal)"></p-chart>
                    @if (obterInfoVelocimetro(grupo); as info) {
                        <div class="speedometer-content">
                            <span class="speedometer-value">{{ info.valorCentro }}</span>
                            <span class="speedometer-label">{{ info.rotulo }}</span>
                        </div>
                    }
                </div>
                @if (obterInfoVelocimetro(grupo); as info) {
                    @if (info.subtitulo) {
                        <div class="speedometer-footer">
                            {{ info.subtitulo }}
                        </div>
                    }
                }
            } @else {
                <div [class]="modal ? 'modal-grafico-container modal-grafico-pizza' : 'estatistica-grafico-container grafico-pizza'">
                    <p-chart [type]="obterTipoGrafico(grupo)" [data]="obterDadosGrafico(grupo)" [options]="obterOpcoesGrafico(grupo, modal)"></p-chart>
                </div>
            }
        }
        @case ('barra') {
            <div [class]="modal ? 'modal-grafico-container' : 'estatistica-grafico-container'">
                <p-chart [type]="obterTipoGrafico(grupo)" [data]="obterDadosGrafico(grupo)" [options]="obterOpcoesGrafico(grupo, modal)"></p-chart>
            </div>
        }
        @case ('lista') {
            @if (modal) {
                <div class="modal-lista-scroll">
                    @for (item of grupo.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                        <div class="estatistica-linha">
                            <div class="estatistica-linha-texto">
                                <span class="estatistica-item-descricao">{{ obterDescricaoItem(item) }}</span>
                                @if (obterComplementoItem(item, grupo)) {
                                    <span class="estatistica-item-complemento">{{ obterComplementoItem(item, grupo) }}</span>
                                }
                                <span class="estatistica-barra"><span [style.width]="obterLarguraBarra(grupo, item)"></span></span>
                            </div>
                            <span class="estatistica-item-total">{{ item.total ?? 0 | number }}</span>
                        </div>
                    }
                </div>
            } @else {
                @for (item of grupo.itens; track item.codigo ?? item.descricao ?? item.ordem) {
                    <div class="estatistica-linha">
                        <div class="estatistica-linha-texto">
                            <span class="estatistica-item-descricao">{{ obterDescricaoItem(item) }}</span>
                            @if (obterComplementoItem(item, grupo)) {
                                <span class="estatistica-item-complemento">{{ obterComplementoItem(item, grupo) }}</span>
                            }
                            <span class="estatistica-barra"><span [style.width]="obterLarguraBarra(grupo, item)"></span></span>
                        </div>
                        <span class="estatistica-item-total">{{ item.total ?? 0 | number }}</span>
                    </div>
                }
            }
        }
    }
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Estatísticas do grupo em tela cheia."
    [(visible)]="exibirModalMaximizados"
    [header]="grupoMaximizado?.titulo ?? ''"
    [style]="{ width: '90vw', maxWidth: '560px' }"
    [breakpoints]="{ '640px': '95vw' }"
    [dismissableMask]="true"
    (onHide)="grupoMaximizado = null"
    styleClass="modal-estatistica-custom"
>
    @if (grupoMaximizado) {
        <div class="estatistica-card modal-card-wrapper" [ngClass]="grupoMaximizado.classeGrupo">
            <div class="estatistica-topo">
                <div class="estatistica-identidade">
                    <span class="estatistica-icone"><i [class]="obterAgrupadorSelecionado().icon"></i></span>
                    <p-tag [rounded]="true" class="grupo-badge">{{ grupoMaximizado.grupo }}</p-tag>
                </div>

                @if (possuiAnalitico(grupoMaximizado)) {
                    <div class="estatistica-acoes" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                        <p-button
                            icon="pi pi-table"
                            styleClass="botao-topo-acao"
                            [text]="true"
                            [rounded]="true"
                            title="Visualizar dados estatísticos"
                            ariaLabel="Visualizar dados estatísticos"
                            (onClick)="$event.stopPropagation(); selecionarEstatisticaAnalitica(grupoMaximizado)"
                        ></p-button>
                    </div>
                }
            </div>

            @if (grupoMaximizado.visualizacao !== 'kpi') {
                <div class="estatistica-total-bloco">
                    @if (obterTotalGrupo(grupoMaximizado) !== null) {
                        <span class="estatistica-total-valor">{{ obterTotalGrupo(grupoMaximizado) | number }}</span>
                        <span class="estatistica-total-label">{{ grupoMaximizado.rotuloTotal }}</span>
                    }
                </div>
            }

            <p class="estatistica-descricao">{{ grupoMaximizado.descricao }}</p>

            <div class="modal-visualizacao-conteudo">
                @if (grupoMaximizado.itens?.length) {
                    <ng-container *ngTemplateOutlet="conteudoEstatistica; context: { $implicit: grupoMaximizado, modal: true }"></ng-container>
                } @else {
                    <div class="estatistica-sem-dados">Sem dados</div>
                }
            </div>
        </div>
    }
</p-dialog>
